import { render, staticRenderFns } from "./QuestionnaireSelection.vue?vue&type=template&id=bccccf54&scoped=true&"
import script from "./QuestionnaireSelection.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireSelection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireSelection.vue?vue&type=style&index=0&id=bccccf54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccccf54",
  null
  
)

export default component.exports